import { Chip, LuneTheme } from '@lune-fe/lune-ui-lib'
import { SxProps } from '@mui/material'
import { ReactElement } from 'react'

export const ExplanationChip = ({
    text,
    testId,
    sx,
    icon,
}: {
    text: string
    testId?: string
    sx?: SxProps
    icon?: ReactElement
}) => {
    const { palette } = LuneTheme

    return (
        <Chip
            label={text}
            icon={icon}
            sx={{
                backgroundColor: `${palette.Grey100}`,
                marginX: 1,
                paddingX: 1,
                paddingY: '6px',
                borderRadius: '20px',
                height: 'auto',
                typography: 'body2',
                '& .MuiChip-label': {
                    whiteSpace: 'nowrap',
                    paddingX: 0,
                },
                '& .MuiChip-icon': {
                    color: 'Grey900',
                    width: '20px',
                    height: '20px',
                    marginRight: 1,
                },
                ...sx,
            }}
            testId={testId}
        />
    )
}

export default ExplanationChip
